import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { useFormik } from 'formik';
import { BeatLoader } from 'react-spinners';
// import Pagination from '../../Pagination';
import Skeleton from 'react-loading-skeleton'
import { Tooltip } from 'antd';
// import { adminMainUrl } from '../../../../../../../Config';
// import { DesignationApi } from '../../../../../../../Redux/action/MasterAction';
import { adminMainUrl } from '../../../../../../../../Config';
import { DesignationApi } from '../../../../../../../../Redux/action/MasterAction';

const IssueDO = ({ accessedModules, accessedPermission }) => {
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [dataOffset, setDataOffset] = useState(0);
    const dataPerPage = 10;
    const [reload, setReload] = useState(false);
    const [spinnerLoader, setSpinnerLoader] = useState(false)
    const [DesignationName, setDesignationName] = useState(null)
    const [DesignationId, setDesignationId] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Number of items per page
    // const { name } = useParams();
    const dispatch = useDispatch();
    const {
        loadingDesignationTypeApi,
        findDesignationTypeData,
        findDesignationTypeDataError,

    } = useSelector(state => state?.MasterReducer);
    useEffect(() => {
        dispatch(DesignationApi(adminMainUrl));
    }, [adminMainUrl, reload]);
    const handleSuccess = () => {
        // Toggle reload to trigger useEffect
        setReload(prev => !prev);
    };

    // Initialize Formik
    const statusChange = async (id) => {
        setSpinnerLoader(true)
        try {
            const response = await fetch(`${adminMainUrl}/api/designation/status-change`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
                    'user_id': Cookies.get('flexichain_user_id'),
                },
                body: JSON.stringify({ id: id.toString() }),
            });

            const data = await response.json();

            if (response.ok) {
                setSpinnerLoader(false)
                handleSuccess(); // Call the success handler
                toast.success(data?.msg);
            } else {
                setSpinnerLoader(false)
                toast.error(data?.msg);
            }
        } catch (error) {
            setSpinnerLoader(false)
            console.error('Network error:', error);
        }
    };

    const handleChange = (id) => {
        // if (accessedPermission.includes("state_change_master_data")) {
        statusChange(id);
        // }
    };
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = findDesignationTypeData?.data

    const totalPages = Math.ceil(findDesignationTypeData?.data?.length / itemsPerPage);

    // Function to change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Function for "Next" and "Previous" buttons
    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    const arr = new Array(5).fill(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys)
    }
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    }
    const [editshow, setEditShow] = useState(false);
    const handleEditClose = () => setEditShow(false);
    const handleEditShow = () => setEditShow(true);
    let formik = useFormik({

        onSubmit: (values) => {
            console.log(values)
        },
    });
    const columns = [
        { title: "Shipment No", dataIndex: "SNo", key: "SNo" },
        { title: "Consignee", dataIndex: "NVOCC", key: "NVOCC" },
        { title: "CAN No.", dataIndex: "action", key: "action" },
        { title: "DO No.", dataIndex: "action", key: "action" },
        { title: "DO Date.", dataIndex: "action", key: "action" },

        { title: "Airline", dataIndex: "Alias", key: "Alias" },
      
        { title: "Flight No/Date", dataIndex: "TrackingURL", key: "TrackingURL" },

      
        
    ];

    const dataSource = [
        {
            key: "", // Add a unique key for each row
            SNo: "", // Changed to camelCase
           
        },
    ]
    const [addShow, setAddShow] = useState(false);
    const handleAddClose = () => setAddShow(false);
    const handleAddShow = () => setAddShow(true);

    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                        Issue DO<span className="count-title">23</span>
                                        </h4>
                                    </div>
                                    <div className="col-4 text-end">
                                        <div className="head-icons">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-original-title="Collapse"
                                                id="collapse-header"
                                            >
                                                <i className="ti ti-chevrons-up" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Page Header */}
                        </div>
                    </div>
                    <div className="card">

                        <div className="card-body">

                            {/* Filter */}
                            <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    <div className="dropdown me-2">
                                        <a
                                            href="javascript:void(0);"
                                            className="dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                        >
                                            <i className="ti ti-sort-ascending-2 me-2" />
                                            Sort{" "}
                                        </a>

                                        <div className="dropdown-menu  dropdown-menu-start">
                                            <ul>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Ascending
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Descending
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Recently Viewed
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Recently Added
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="icon-form mb-3 mb-sm-0 me-2">
                                        <span className="form-icon">
                                            <i className="ti ti-search" />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Search "
                                            name='search_by'
                                        // value={searchText}
                                        // onChange={(e) => setSearchText(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-sorts dropdown me-2">
                                        <Tooltip placement="top" title="Filter">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="dropdown"
                                                data-bs-auto-close="outside"
                                                // className='py-1'
                                                style={{
                                                    paddingTop: "7px",
                                                    paddingBottom: "6px"
                                                }}
                                            >
                                                <i className="ti ti-filter-share me-0" />
                                                {/* Filter */}
                                            </a>
                                        </Tooltip>
                                        <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                                            <div className="filter-set-view">
                                                {/* <div className="filter-set-head">
                                                    <h4>
                                                        <i className="ti ti-filter-share" />
                                                        Filter
                                                    </h4>
                                                </div> */}
                                                <table className="content-table">
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Consignee</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm ms-2"
                                                                    placeholder=" "
                                                                    name="request_no"
                                                                // value={formik.values.request_no}
                                                                // onChange={formik.handleChange}
                                                                // onBlur={formik.handleBlur}
                                                                // value={status_id}
                                                                // onChange={(e) => setStatus_id(e.target.value)}
                                                                />
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Show</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm ms-2"
                                                                    placeholder=""
                                                                    name="name"
                                                                // value={formik.values.name}
                                                                // onChange={formik.handleChange}
                                                                // onBlur={formik.handleBlur}
                                                                // value={full_name}
                                                                // onChange={(e) => setName(e.target.value)}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Airline</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm ms-2"
                                                                    placeholder=""
                                                                    name="email"
                                                                // value={formik.values.email}
                                                                // onChange={formik.handleChange}
                                                                // onBlur={formik.handleBlur}
                                                                // value={email}
                                                                // onChange={(e) => setEmail(e.target.value)}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Date</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="date"
                                                                    className="form-control form-control-sm ms-2"
                                                                    placeholder=""
                                                                    name="phone"
                                                                // value={formik.values.phone}
                                                                // onChange={formik.handleChange}
                                                                // onBlur={formik.handleBlur}
                                                                // value={mobileNumber}
                                                                // onChange={(e) => setMobileNumber(e.target.value)}
                                                                />
                                                            </td>
                                                        </tr>
                                                     
                                                     
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Flight No.</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm ms-2"
                                                                    placeholder=""
                                                                    name="phone"
                                                                // value={formik.values.phone}
                                                                // onChange={formik.handleChange}
                                                                // onBlur={formik.handleBlur}
                                                                // value={mobileNumber}
                                                                // onChange={(e) => setMobileNumber(e.target.value)}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label htmlFor="#">Flight Date</label>
                                                            </td>
                                                            <td className="input_box_filter">
                                                                {" "}
                                                                <input
                                                                    type="date"
                                                                    className="form-control form-control-sm ms-2"
                                                                    placeholder=""
                                                                    name="phone"
                                                                // value={formik.values.phone}
                                                                // onChange={formik.handleChange}
                                                                // onBlur={formik.handleBlur}
                                                                // value={mobileNumber}
                                                                // onChange={(e) => setMobileNumber(e.target.value)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div className="filter-reset-btns">
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <a className="btn btn-light">
                                                                Reset
                                                            </a>
                                                        </div>
                                                        <div className="col-6">
                                                            <button type='submit' className="btn btn-primary w-100">
                                                                Filter
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="icon-form">
                                        <span className="form-icon">
                                            <i className="ti ti-calendar" />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control bookingrange"
                                            placeholder=""
                                        />
                                    </div> */}
                                </div>
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    <Tooltip placement="top" title="Print Data">
                                        <div
                                            className="btn btn-primary cursor-pointer me-2"
                                        >
                                            <i className="ti ti-printer text-white"></i>
                                            {/* <ReactTooltip id="print" place="top" effect="solid" /> */}
                                        </div>
                                    </Tooltip>
                                    <Tooltip placement="top" title="Export Data">
                                        <div
                                            className="btn btn-primary cursor-pointer me-2"
                                        >
                                            <i className="fas fa-file-export text-white"></i>
                                            {/* <ReactTooltip id="export" place="top" effect="solid" /> */}
                                        </div>
                                    </Tooltip>
                                    <button type='submit' className="btn btn-primary me-2">
                                        Search
                                    </button>
                                    <a
                                        className='btn btn-light me-2'
                                    //   style={{ background: "#04aed2", marginTop: "7px", marginBottom: "15px" }}
                                    >
                                        Clear
                                    </a>
                                    {/* <div
                                        className="btn btn-primary cursor-pointer me-2"
                                        onClick={handleAddShow}
                                    >
                                        <i className="ti ti-square-rounded-plus me-2" />
                                        Add Shipping Line
                                    </div> */}

                                </div>
                            </div>
                            <div className="table-responsive custom-table">
                                <Table className="table datanew dataTable no-footer" pagination={false}
                                    dataSource={dataSource} columns={columns} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default IssueDO